import { JSX, Signal, createSignal, splitProps } from 'solid-js';
import style from './st-textarea.module.css'
import { inherits } from 'util';

export class TextAreaProps {
    label!: string;
    value!: Signal<string>;
    placeholder?: string;
    selected? = false;
    focused? = false;
    required? = false;
}

type PropsType = TextAreaProps & Omit<JSX.HTMLElementTags['textarea'], keyof TextAreaProps>

export default function Textarea(props: PropsType) {
    const [local, others] = splitProps(props, ['label', 'value', 'placeholder', 'selected', 'focused', 'required', 'class'])
    const [value, setValue] = props.value ?? createSignal('')

    return (
        <>
            <label>
                <span hidden={!props.label}>{props.label}</span>
                <textarea
                    placeholder={props.placeholder || ''}
                    class={style['st-textarea'] + ` ${props.class ?? ''}`}
                    value={value()}
                    onInput={(e: Event) => setValue((e.target as HTMLTextAreaElement).value)}
                    required={props.required}
                    {...others}
                />
            </label>
        </>
    )
}

Textarea.defaultProps = new TextAreaProps() 